<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <projects-grid [hidden]="!showGrid" [workspace]="this"></projects-grid>
    <projects-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                   [workspace]="this"
                   [showPrevBtn]="previousButtonEnabled"
                   [showNextBtn]="nextButtonEnabled"
                   (showPrevious)="showPrevious()"
                   (showNext)="showNext()">
    </projects-form>
    <projects-grid-export-pane *ngIf="showProjectsExportPane"
                               [canClose]="true"
                               (closePane)="closeExportPane()">
    </projects-grid-export-pane>
</div>
</div>
